import React, { memo } from "react";
import PropTypes from "prop-types";
import cs from "classnames";

import "./badge-container.scss";

const BadgeContainer = (props) => {
  return (
    <div className={cs("on-badge-container")}>
      <div>
        <div class="content">
          <div>
            <p>
              <img
                loading="lazy"
                class="alignnone"
                src="https://www.homelight.com/agents/agent-awards/benjamin-strock-ca-01337838-4303/top_producer_2020"
                alt=""
                width="125"
                height="125"
              />
              &nbsp;&nbsp;
              <img
                loading="lazy"
                class="alignnone"
                src="https://www.homelight.com/agents/agent-awards/benjamin-strock-ca-01337838-4303/fast_seller_2020"
                alt=""
                width="125"
                height="125"
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

BadgeContainer.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.any,
  }),
};

BadgeContainer.defaultProps = { location: { pathname: "" } };

export default memo(BadgeContainer);
